<template>
  <div class="learning-path-card">
    <a
      :href="route('learning-paths.show', { learning_path: learningPath.id })"
      :style="backgroundImage"
    >
      <div class="details">
        <h2>{{ learningPath.name }}</h2>
        <p>{{ learningPath.length }}</p>
      </div>
      <div class="overlay black-overlay"></div>
      <div class="overlay color-overlay"></div>
      <div class="featured" v-if="learningPath.is_featured">Featured</div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    learningPath: { type: Object, required: true }
  },
  computed: {
    backgroundImage() {
      if (!this.learningPath.image) {
        return null;
      }
      return `background-image:url('${this.learningPath.image.url}');`;
    }
  }
};
</script>